import type { IconDefinition } from '../index.tsx';

export const iconMobile: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconMobile',
  icon: [
    16,
    16,
    [],
    '',
    'M4 0C2.89543 0 2 0.895431 2 2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V2C14 0.895431 13.1046 0 12 0H4ZM12 3H4V13H12V3Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
